

import { put, select, takeLatest } from "redux-saga/effects";
import { Action, ActionCreator } from "redux";
import { getIsRedirectToSurveyEnabled } from "../store/Survey/selectors";
import { changeTypeOfFinalTransactionCompleted } from "../store/Survey/actions";

import { Routes } from "../constants/routes";
import Client from "../services/Client";
import { TypeOfFinalTransaction, ErrorCodes,ClientEventScreen } from "../dtos/KioskDtos.dtos";
import { push } from "../store/Routing/actions";

export const REDIRECT_TO_SURVEY = "REDIRECT_TO_SURVEY";
export type REDIRECT_TO_SURVEY = typeof REDIRECT_TO_SURVEY;

export interface RedirectToSurveyAction extends Action {
    type: REDIRECT_TO_SURVEY;
    payload: {
        alternateRedirect: Action | null,
        typeOfActionCompleted: TypeOfFinalTransaction,
        context?: ErrorCodes | ClientEventScreen
    };
}

export const redirectToSurvey: ActionCreator<RedirectToSurveyAction> = (alternateRedirect: Action, typeOfActionCompleted: TypeOfFinalTransaction, context?: ErrorCodes | ClientEventScreen) => ({
    type: REDIRECT_TO_SURVEY,
    payload: {
        alternateRedirect,
        typeOfActionCompleted,
        context
    },
});

export function* redirectToSurveyController(action: RedirectToSurveyAction) {
    if(yield select(getIsRedirectToSurveyEnabled)) {
        if (action.payload.typeOfActionCompleted === TypeOfFinalTransaction.CancelledOnTheirOwn){
            Client.logManualCancelEvent(action.payload.context as ClientEventScreen)
        }
        yield put(changeTypeOfFinalTransactionCompleted(action.payload.typeOfActionCompleted, action.payload.context));
        yield put(push(Routes.satisfactorySurvey));
    } else {
        yield put(action.payload.alternateRedirect);
    }
}

export function* watchForAllSurveySagas() {
    yield takeLatest(REDIRECT_TO_SURVEY, redirectToSurveyController);
}



// WEBPACK FOOTER //
// ./src/sagas/surveyRedirectSaga.ts